export const localEs = {}
